import { AnyAction } from 'redux';
import {
  createActionPlayerSetCurrentIsFavorite,
  createActionPlayerSetCurrentTrack,
  createActionPlayerSetIsActive,
  createActionPlayerSetIsPaused,
  createActionPlayerSetPlayer,
  createActionPlayerSetPosition,
  createActionPlayerSetRepeat,
  createActionPlayerSetShuffle,
  createActionPlayerSetVolume,
} from '../actions/player';

export interface TStatePlayer {
  player?: Spotify.Player;
  isPaused: boolean;
  isActive: boolean;
  position: number;
  repeat: boolean;
  shuffle: boolean;
  currentTrack?: {
    id: string | null;
    uri: string;
    duration_ms: number;
    name: string;
    album: {
      uri: string;
      images: { url: string }[];
    };
    artists: { uri: string; name: string }[];
  };
  currentIsFavorite: boolean;
  volume: number;
}

const initialState: TStatePlayer = {
  isPaused: false,
  isActive: false,
  position: 0,
  repeat: false,
  shuffle: false,
  currentTrack: {
    id: '',
    uri: '',
    duration_ms: 0,
    name: '',
    album: {
      uri: '',
      images: [{ url: '' }],
    },
    artists: [{ uri: '', name: '' }],
  },
  currentIsFavorite: false,
  volume: 50,
};

const player = (
  state: TStatePlayer = initialState,
  action: AnyAction
): TStatePlayer => {
  if (createActionPlayerSetPlayer.doesMatch(action)) {
    return { ...state, player: action.payload };
  }

  if (createActionPlayerSetIsPaused.doesMatch(action)) {
    return { ...state, isPaused: action.payload };
  }

  if (createActionPlayerSetIsActive.doesMatch(action)) {
    return { ...state, isActive: action.payload };
  }

  if (createActionPlayerSetCurrentTrack.doesMatch(action)) {
    return { ...state, currentTrack: action.payload };
  }

  if (createActionPlayerSetPosition.doesMatch(action)) {
    return { ...state, position: action.payload };
  }

  if (createActionPlayerSetRepeat.doesMatch(action)) {
    return { ...state, repeat: action.payload };
  }

  if (createActionPlayerSetShuffle.doesMatch(action)) {
    return { ...state, shuffle: action.payload };
  }

  if (createActionPlayerSetCurrentIsFavorite.doesMatch(action)) {
    return { ...state, currentIsFavorite: action.payload };
  }

  if (createActionPlayerSetVolume.doesMatch(action)) {
    return { ...state, volume: action.payload };
  }

  return state;
};

export default player;
